// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__dZC2l","addUserButton":"styles_addUserButton__cw46x","buttonContentWrapper":"styles_buttonContentWrapper__8O2Ah","addUserIcon":"styles_addUserIcon__fJ9pr"};